<template>
  <div class="mask" v-if="showStep1Modal">
    <div class="form-section message-modal">
      <h2 class="curr-step-title">{{ i18n.t('signup-visa-card-details') }}</h2>
      <div class="curr-step-desc">
        <span class="step-desc">{{ i18n.t('signup-step-1-desc') }}</span>
        <div class="quession-group">
          <img src="~img/icon-question.png" alt="question icon" class="icon-question" />
          <div class="quession">
            <p class="quession-title">{{ i18n.t('details') }}</p>
            <p class="quession-ctn">{{ i18n.t('whyVc') }}</p>
          </div>
        </div>
      </div>

      <!-- 表单组件部分 -->
      <restpwd-form
        v-bind="step1Config"
        :formValue="step1FormValue"
        :errMessage="errMessage"
        @changeFormValue="formValueChange"
      >
      </restpwd-form>

      <div class="term-desc">
        <div class="check-box" @click="toggleCheck">
          <img src="~img/icon-check.png" alt="checked icon" v-if="checked" />
        </div>
        <div class="desc">
          <p>
            {{ i18n.t('signup-checkbox-desc') }}
          </p>
          <p>
            <span class="desc-serial">1.</span>{{ i18n.t('signup-terms-desc-1') }} <br />
            <span class="desc-serial">2.</span>{{ i18n.t('signup-terms-desc-2') }}
          </p>
          <!-- <i18n-t keypath="signup-see-tnc" tag="p">
            <a href="" target="_blank" class="tc-link">{{ i18n.t('tnc') }}</a>
          </i18n-t> -->

          <!-- TODO: 暂时处理<i18n></i18n>组件在全局弹窗下warring问题 -->
          <p>
            {{ i18n.t('see1') }}
            <a href="" target="_blank" class="tc-link">{{ i18n.t('signup-tnc') }}</a>
            {{ i18n.t('see2') }}
          </p>
        </div>
        <p v-if="showCheckedErr && !checked" class="show-errors">{{ i18n.t('errMsg1') }}</p>
      </div>
      <div class="btn-wrapper">
        <button class="dpi-button" @click="back">{{ i18n.t('cancel') }}</button>
        <button class="dpi-button dpi-button-primary" @click="vcesVerify"
          >{{ i18n.t('continue') }}
        </button>
      </div>
    </div>
    <!-- 消息弹窗 -->
    <msg-modal
      :componentShow="componentShow"
      :options="messageModalOptions"
      @confirm="handleMsgConfirm"
    >
    </msg-modal>
  </div>
</template>

<script>
  import { step1Config } from './step1.config';
  import restpwdForm from '@/components/BaseUi/Form/src';
  import verity from '@/utils/verify';
  // 解决获取不到$t的问题
  import i18n from '@/i18n/index';
  import { handleCreateSession } from '@/utils/createSession';

  const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
  import store from '@/store';
  import { formatCardNo } from '@/components/BaseUi/Form/utils/index';
  import { encryptAES } from '@/utils';
  import MsgModal from '@/components/BaseUi/MessageModal/src/index.vue';

  // 解决获取不到$router的问题
  // import router from '@/router';

  export default {
    name: 'step1Modal',
    components: {
      restpwdForm,
      MsgModal,
    },

    props: {
      options: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        i18n,
        step1Config,
        checked: true,
        errMessage: [],
        showCheckedErr: '',
        showStep1Modal: false,
        step1FormValue: {},
        argData: [],
        // 弹窗展示部分 start
        token: '',
        componentShow: false,
        // 弹窗展示部分 start
        messageModalOptions: {
          image: false,
          // descGroup: {
          //   desc1: 'mayHave',
          //   desc2: 'reEntering',
          //   subDesc: ['have1', 'have2', 'have3'],
          // },
          descGroup: {
            desc1: 'mayHave',
            desc2: 'reEntering',
            subDesc: ['have1', 'have2', 'have3'],
          },
          confirmBtn: 'ok',
          justHide: true,
        },
      };
    },

    methods: {
      handleMsgConfirm() {
        this.componentShow = false;
      },
      show() {
        this.step1FormValue = this.options;
        this.showStep1Modal = true;
      },

      hide() {
        this.showStep1Modal = false;
      },

      // 获取到组件内修改后返回的数据
      formValueChange(data) {
        this.step1FormValue = { ...this.step1FormValue, ...data };
      },

      toggleCheck() {
        this.checked = !this.checked;
      },

      back() {
        this.hide();
      },

      vcesVerify() {
        verity(this.step1FormValue).then(errMsg => {
          if (errMsg.pass && this.checked) {
            this.checkVcesVerify(this.step1FormValue);
            this.errMessage = [];
          } else {
            if (!errMsg.pass) {
              this.errMessage = errMsg;
            }
            if (!this.checked) {
              this.showCheckedErr = true;
            } else {
              this.showCheckedErr = false;
            }
          }
        });
      },

      async checkVcesVerify(formValue) {
        try {
          const { cdeDate, visaCardNum, projectId } = formValue;
          const res = await this.$http.login.vcesVerify({
            channel: projectId,
            tokenCode: visaCardNum,
            expiryMonth: cdeDate.expiryMonth,
            expiryYear: cdeDate.expiryYear,
            lang: localStorage.getItem('lang'),
          });
          if (res?.state === '1') {
            this.token = res.result.id;
            console.log('res.result.id', res.result.id);
            await this.checkCardNoStatus(this.token);
          } else if (res?.state === '00') {
            this.hide();
            res?.note &&
              this.$messageModal.show({
                image: false,
                desc: res?.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
                callback: this.callbackFunc,
              });
          }
        } catch (error) {
          console.error(error);
          this.hide();
        }
      },

      step3HandleRegister(value) {
        console.log('value', value);

        this.registered(value);
      },
      async registered(paymentHash) {
        this.$loading.show();
        const arg = this.argData;
        const { email, fname, lname, birthday, visaCardName, mobileNumber, exphone, country } = arg;
        const { password } = arg[1];
        const data = {
          email,
          exphone,
          password,
          birthday,
          encryptCustomerInput: paymentHash,
          token: this.token,
          lang: localStorage.getItem('lang'),
          firstName: fname,
          lastName: lname,
          phone: mobileNumber.slice(exphone.length + 1),
          countryId: country,
          cardHolderName: visaCardName,
        };
        const res = await this.$http.login.register(data);
        if (res.state === '11') {
          // 帮助用户登录->登录成功后请求龙卡信息
          await this.userLoginAndGetDragonCard(arg);
        } else if (res.state === '00' && res?.errorCode === 'visa.ingenico.register-error') {
          this.$loading.hide();
          res?.note && store.commit('showMessageModal', { key: res.note, i18nNeed: false });
        } else if (res.state === '00' && res?.errorCode === 'visa.card.ingenico.fail') {
          // const note = res?.note.replace(/\r\n/g, '</br>').replace(/(-)/, '·')
          // res?.note && this.showMessageModal({ key: note, i18nNeed: false });
          this.$loading.hide();
          this.componentShow = true;
          return;
        } else if (res.state === '00') {
          this.$loading.hide();
          res?.note && store.commit('showMessageModal', { key: res.note, i18nNeed: false });
        }
      },
      async userLoginAndGetDragonCard(arg) {
        const { confirmEmail } = arg;
        const { password } = arg[1];
        const loginData = {
          password,
          username: confirmEmail,
          version: '1.0.0',
          device: 'web',
          deviceName,
        };

        const successLogin = await this.handleLogin(loginData);

        // 通过用户信息获取到龙腾卡信息
        const { userId, sessionId } = successLogin.user;
        const dragonCardData = {
          lang: localStorage.getItem('lang'),
          device: 'web',
          version: '1.0.0',
          userId,
          sessionId,
          deviceName,
        };

        const dragonCardMsg = await this.getDragonCard(dragonCardData);
        if (dragonCardMsg.state === '11') {
          this.$loading.hide();
          const { bankLogo, bankLogoThumbnails, englishName, dragoncode, validDate } =
            dragonCardMsg?.card;
          const [year, month, day] = validDate.split('-');
          const formatValidData = `${day}/${month}/${year}`;
          const formatDragoncode = formatCardNo(dragoncode);
          this.cardData = {
            bankLogo,
            bankLogoThumbnails,
            englishName,
            dragoncode: formatDragoncode,
            validData: formatValidData,
          };
          sessionStorage.setItem('getcardData', JSON.stringify(this.cardData));
          store.commit('setState', {
            state: 'getcardData',
            values: this.cardData,
          });
          // this.currentStep = 4;
          // this.registerSuccess = true;
        } else {
          console.error(dragonCardMsg.note);
          this.$loading.hide();
        }
      },
      handleLogin(data) {
        this.$loading.show();

        return new Promise(resolve => {
          this.$http.login
            .userLogin(data)
            .then(res => {
              if (res.state === '11') {
                this.$loading.hide();
                this.hide();
                sessionStorage.setItem('token', encryptAES(res.user.sessionId));
                // sessionStorage.setItem('sessionId', encryptAES(res.user.sessionId));
                sessionStorage.setItem('isLogin', true);
                sessionStorage.setItem('user', encryptAES(JSON.stringify(res.user)));
                sessionStorage.setItem('ingenicoFailRegister', true);
                store.commit('setState', {
                  state: 'ingenicoFailRegister',
                  values: true,
                });
                store.commit('setState', {
                  state: 'isLogin',
                  values: true,
                });
                store.commit('setState', {
                  state: 'userInfo',
                  values: res.user,
                });
                if (res.visaCardType) {
                  sessionStorage.setItem('visaCardType', res.visaCardType);
                  store.commit('setState', {
                    state: 'visaCardType',
                    values: res.visaCardType,
                  });
                }
                resolve(res);
              } else if (res.state === '00') {
                this.$loading.hide();
                res?.note && store.commit('showMessageModal', { key: res.note, i18nNeed: false });
              }
            })
            .catch(err => {
              console.error(err);
              this.$loading.hide();
            });
        });
      },

      // 获取龙腾卡信息
      getDragonCard(data) {
        this.$loading.show();
        return new Promise(resolve => {
          this.$http.login.getDragonCard(data).then(
            res => {
              if (res.state === '11') {
                this.$loading.hide();
                resolve(res);
              } else if (res.state === '00') {
                this.$loading.hide();
                res?.note && store.commit('showMessageModal', { key: res.note, i18nNeed: false });
              }
            },
            err => {
              console.error(err);
              this.$loading.hide();
            },
          );
        });
      },

      async checkCardNoStatus(token) {
        // if (this?.options?.noPerform) {
        //   const formValue = this.step1FormValue;
        //   const projectId = { projectId: this.projectId }
        //   console.log('asd')
        //   handleCreateSession({ ...formValue, ...projectId }, null)
        //   // this.$emit('ingenicoCheck', );
        //   // this.$emit('token', token);
        //   return;
        // }
        try {
          const res = await this.$http.login.checkCardNoStatus({
            token,
            lang: localStorage.getItem('lang'),
          });
          if (res.state === '11') {
            // await handleCreateSession({ ...formValue, ...projectId });
            // this.step3HandleRegister(formValue)
            this.$nextTick(() => {
              const formValue = { ...this.options, ...this.step1FormValue };
              const projectId = { projectId: this.projectId };
              this.argData = formValue;
              handleCreateSession({ ...formValue, ...projectId }, this.step3HandleRegister);
            });
          } else if (res?.state === '00') {
            this.hide();

            res?.note &&
              this.$messageModal.show({
                image: false,
                desc: res?.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
                callback: this.callbackFunc,
              });
          }
        } catch (error) {
          console.error(error);
          this.hide();
        }
      },

      // 消息(message)弹窗关闭后的事件回调
      callbackFunc() {
        this.show();
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile';
</style>
